/* eslint-disable react-hooks/exhaustive-deps */
// React Imports
import { useEffect, useLayoutEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";

// Icons Imports
import ICONS from "../../../../assets/Icons/index.js";

// Redux Imports
import {
  addReimbursementTxnLabel,
  ReimbursementTxnAccountDetail,
  reimbursementTxnApproval,
  ReimbursementTxnDeniedApproval,
  ReimbursementTxnWaitingApproval,
  removeReimbursementTxnLabel,
  setDetailDataToApprovalData,
  setDetailDataToRejectData,
} from "../../../../redux/features/reimbursementTransaction/index.js";

// Component Imports
import OwnerAccountDetailsPopUp from "../../../../components/Accounts/OwnerAccount/OwnerAccountDetailsPopUp/index.jsx";
import CommonTimeLineCard, {
  addLifeCycleStatus,
} from "../../../../components/CommonTimeLineCard/index.jsx";
import FullScreen from "../../../../components/FullScreen/index.jsx";
import Loader from "../../../../components/Loader/Index.jsx";
import ReimbursementTxnViewAllPopup from "../../../../components/ReimbursementTxnViewAllPopup/index.jsx";
import CommonBankLogo from "../../../../components/_utils/CommonBankLogo/index.jsx";
import Chips from "../../../../components/_utils/CommonButtons/Chips/index.jsx";
import SwitcherTabs from "../../../../components/_utils/CommonButtons/SwitcherTabs/index.jsx";
import TopNavSmallButton from "../../../../components/_utils/CommonButtons/TopNavSmallButton/index.jsx";
import CommonContainerCard from "../../../../components/_utils/CommonContainerCard/index.jsx";
import CommonDetailCard from "../../../../components/_utils/CommonDetailCard/index.jsx";
import CommonInfoBox from "../../../../components/_utils/CommonInfoBox/index.jsx";
import CommonAssignLabelPopup from "../../../../components/_utils/CommonPopups/CommonAssignLabelPopup/index.jsx";
import LargePopupRedirect from "../../../../components/_utils/CommonPopups/CommonLargePopupRedirect/index.jsx";
import SmallPopupWithInput from "../../../../components/_utils/CommonSmallPopupWithInput/index.jsx";
import CommonToast from "../../../../components/_utils/CommonToast/index.jsx";
import { formatAccountNumber } from "../../../../components/_utils/FormatAccountNumber/index.js";
import TimelineStatusBar from "../../../../components/_utils/TimelineCommonComponents/TimelineStatusBar/index.jsx";
import TimelinePopupContent from "../../../../components/_utils/TimelinePopupContent/index.jsx";
import TitleSubtitlePair from "../../../../components/_utils/TitleSubtitlePair/index.jsx";
import MediumImagePopup from "../../../../components/_utils/MediumImagePopup/index.jsx";

// Utils Imports
import formatCurrency from "../../../../utils/CurrencyFormater.js";
import {
  GlobalConfiguration,
  IntervalConfiguration,
  RejectReasonLength,
  TimelineConfiguration,
} from "../../../../utils/configurationProvider.js";
import formatDateViewAll from "../../../../utils/formatDateViewAll.js";
import TEXT from "../../../../utils/globalText.js";
import useCategories from "../../../../utils/useCategories.js";
import { toast } from "react-toastify";
import TopNavComponent from "../../../../components/_utils/CommonTopNav/TopNavComponent/index.jsx";
import ReimbursementAccountDetailsPopup from "../../../../components/_utils/ReimbursementAccountDetailsPopup/index.jsx";
import UniversalRefreshToast from "../../../../components/_utils/UniversalRefreshToast/index.jsx";
import useRestrictedAction from "../../../../hooks/useRestrictedAction.js";
import {
  getOutsideBankingHoursLabel,
  isOutsideBankingHours,
} from "../../../../utils/bankingHours.js";
import SmallPopupWithBulletPoints from "../../../../components/_utils/CommonSmallPopupWithBulletPoint/index.jsx";
import CommonAlertCard from "../../../../components/_utils/CommonAlertCard/index.jsx";

const ReimbursementTxnDetails = ({
  bene_txn_id,
  type,
  setTransactionFilterData,
  setTransactionFilterID,
  typeMulti,
  typeSingle,
  closeDetailModal,
  onRejectSuccess,
  onApproveSuccess,
}) => {
  const dispatch = useDispatch();
  const isSubmittingRef = useRef(false);
  const leftContentRef = useRef(null);
  const labelActionDispatchedRef = useRef(false);
  const cardRefs = useRef({});
  const cardRefsDist = useRef({});
  const { showRestrictedAction, RestrictedActionPopup } = useRestrictedAction();
  const location = useLocation();
  const navigate = useNavigate();
  const categoryMapper = useCategories();

  const { id: idFromParams } = useParams();
  const { services } = useSelector((state) => state.refreshToken);
  const { ReimbursementTxnAccountData } = useSelector(
    (state) => state.reimbursementTransaction,
  );
  const [checkTransaction, setCheckTransaction] = useState(false);
  const [isFocused, setIsFocused] = useState(false);
  const [declineReason, setDeclineReason] = useState("");
  const [showLoader, setShowLoader] = useState(false);
  const [historyPopup, setHistoryPopup] = useState(false);
  const [txnHistoryId, setTxnHistoryId] = useState("");
  const [txnHistoryAccountName, setTxnHistoryAccountName] = useState("");
  const [categoryName, setcategoryName] = useState("");
  const { typeSingleMob } = location.state || {};
  const [alertPopUp, setAlertPopUp] = useState(false);
  const [showSupportDetails, setShowSupportDetails] = useState(
    typeSingle === "Additional_Details" ||
      typeMulti === "MultiApproval_Session_Data" ||
      typeSingleMob === "Additional_Details"
      ? true
      : false,
  );
  const [showAssignedLabels, setShowAssignedLabels] = useState(false);
  const [viewTxnDetails, setViewTxnDetails] = useState([]);
  const [loading, setLoading] = useState(true);
  const [labelPopupLoading, setLabelPopupLoading] = useState(false); // Isolated loading state for popup
  const [showDeclineModal, setShowDeclineModal] = useState(false);
  const [beneTxnDetailsId, setbeneTxnDetailsId] = useState("");
  const [infoBox, setInfoBox] = useState(false);
  const [beneAccountDetailpop, setBeneAccountDetailpop] = useState(false);
  const [ownerDetailpop, setOwnerDetailpop] = useState(false);
  const [showApprovalTimeline, setShowApprovalTimeline] = useState(false);
  const [showDistributionTimeline, setShowDistributionTimeline] =
    useState(false);
  const [showLabelsPopup, setShowLabelsPopup] = useState(false);
  const [labels, setLabels] = useState([]);
  const [labelDetails, setLabelDetails] = useState([]);
  const [btnClicked, setbtnClicked] = useState({});
  const [opentimelinepopup, SetopenTimelinePopup] = useState(false);
  const [index, setIndex] = useState(GlobalConfiguration?.lengthCheckZero);
  const [prevIndex, setPrevIndex] = useState(
    GlobalConfiguration?.lengthCheckZero,
  );
  const [animationClass, setAnimationClass] = useState("");
  const [openApprovalTimeline, setOpenApprovalTimeline] = useState([]);
  const [openDistributionTimeline, setOpenDistributionTimeline] = useState([]);
  const supportInfoTTDefaultText = "Copy to clipboard";
  const [supportInfoTT, setSupportInfoTT] = useState(supportInfoTTDefaultText);
  const [showBanner, setShowBanner] = useState(false);
  const [isOutsideBankingHoursActive, setIsOutsideBankingHoursActive] =
    useState(isOutsideBankingHours());
  const [popupCatName, setPopupCatName] = useState("");
  const [approvalNotPermitted, setApprovalNotPermitted] = useState(false);
  const id = bene_txn_id ?? idFromParams;

  const [txnLabelfilter, setTxnLabelFilter] = useState("");
  const [loadingBox, setLoadingBox] = useState(false);
  const [copyTxnId, setTxnId] = useState(false);
  const [copyDistributionId, setCopyDistributionId] = useState(false);

  const [openImageUrl, setOpenImageUrl] = useState(false);
  const [selectedImage, setSelectedImage] = useState({});

  const resetAllTimelines = () => {
    setOpenApprovalTimeline(
      new Array(
        viewTxnDetails?.[GlobalConfiguration.lengthCheckZero]?.logs?.length ||
          GlobalConfiguration.lengthCheckZero,
      ).fill(false),
    );

    setOpenDistributionTimeline(
      new Array(
        viewTxnDetails?.[GlobalConfiguration.lengthCheckZero]?.distribution_logs
          ?.length || 0,
      ).fill(false),
    );
  };

  const bene_account_id =
    ReimbursementTxnAccountData?.transaction?.[0]?.beneficiary_account_id;

  const popupcloseIcons = () => {
    resetAllTimelines();
    SetopenTimelinePopup(false);
    setShowApprovalTimeline(false);
    setShowDistributionTimeline(false);
  };

  async function fetchData(isSilent = false) {
    // setLoading(true);
    if (!id) return;
    if (!isSilent) setLoading(true);

    // const targetId = id ?? bene_txn_id;

    // let entityId = ReimbursementTxnAccountData?.entity_id;
    // if (!entityId || !beneTxnDetailsId) return;

    // if (targetId && beneTxnDetailsId !== targetId) return;

    // const isPendingWithApprovalService =
    //   ReimbursementTxnAccountData?.lifecycle_status === "pending" &&
    //   services?.includes("AReimbursementTxn");

    // if (!isPendingWithApprovalService) {
    //   setCheckTransaction(false);
    //   return;
    // }

    try {
      let response = await dispatch(ReimbursementTxnAccountDetail(id));
      setLabels(response?.payload?.summary?.available_labels ?? []);
      setLabelDetails(response?.payload?.transaction?.[0]?.labels || []);
      if (!showLabelsPopup) {
        setShowAssignedLabels(false);
        setShowSupportDetails(false);
        setIndex(GlobalConfiguration.lengthCheckZero);
      }
      if (response?.error?.message === "Request failed with status code 404") {
        navigate("*");
      }
      // const response1 = await dispatch(
      //   reimbursementTxnApproval({
      //     entityId,
      //     txn_id: [beneTxnDetailsId],
      //   }),
      // );

      // const transactionsData = response1?.payload?.transactions || [];

      // if (transactionsData.length === 0) {
      //   setCheckTransaction(false);
      //   setApprovalNotPermitted(true);
      //   return;
      // }
      // const transactionExists = transactionsData.some(
      //   (obj) => obj.txn_id === beneTxnDetailsId,
      // );
      // setCheckTransaction(transactionExists);
    } catch (error) {
      console.error("Failed to load the transaction details", error);
      // setCheckTransaction(false);
    } finally {
      if (!isSilent) setLoading(false);
    }
  }

  const handleClose = () => {
    setShowLabelsPopup(false);
    toggleAssignedLabels();
    setIndex(GlobalConfiguration.lengthCheckOne);
  };

  const handleTimelinePopup = () => {
    if (type === "bene_txn_detail_modal") {
      actionRestricted();
    } else {
      SetopenTimelinePopup(true);
      setShowApprovalTimeline(true);
      if (!showApprovalTimeline) {
        setShowDistributionTimeline(false);
      }
      setOpenDistributionTimeline(false);
    }
  };

  const toggleDetails = () => {
    setShowSupportDetails(false);
    setShowAssignedLabels(false);
  };

  const toggleSupportDetails = () => {
    setShowSupportDetails(true);
    setShowAssignedLabels(false);
  };

  const toggleAssignedLabels = () => {
    setShowAssignedLabels(true);
    setShowSupportDetails(false);
  };

  useEffect(() => {
    const updateBankingHoursStatus = () => {
      const nextStatus = isOutsideBankingHours();
      setIsOutsideBankingHoursActive((prev) =>
        prev === nextStatus ? prev : nextStatus,
      );
    };

    updateBankingHoursStatus();
    const intervalId = setInterval(
      updateBankingHoursStatus,
      IntervalConfiguration.intervalMedium,
    );

    return () => clearInterval(intervalId);
  }, []);

  useEffect(() => {
    if (!isOutsideBankingHoursActive) {
      setShowBanner(false);
    }
  }, [isOutsideBankingHoursActive]);

  const outsideBankingHoursLabel = getOutsideBankingHoursLabel();

  function handleOpenBanner() {
    setShowBanner(true);
  }

  const computeVariant = (value, focused) => {
    const length = (value ?? "").trim().length;

    if (length === 0) return "default";

    if (length >= GlobalConfiguration.rejectReasonMinLength) {
      return "verified";
    }

    return focused ? "typing" : "error";
  };

  // const handleApproveTransaction = async (id) => {
  //   UniversalRefreshToast("Approving transaction");

  //   let res;

  //   res = await dispatch(ReimbursementTxnWaitingApproval(id));
  //   toast.dismiss();
  //   // fetchData();

  //   if (res?.payload === undefined) {
  //     setNetworkError(
  //       "An error occured while taking action on this transaction",
  //     );
  //     setTimeout(() => {
  //       CommonToast({
  //         text: "An error occured while taking action on this transaction",
  //         icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
  //         variant: "var(--error)",
  //         btnProps: {
  //           isDisabled: false,
  //           enabledTextColor: "var(--text-primary)",
  //           enabledBgColor: "var(--primary-bg)",
  //         },
  //       });
  //     }, IntervalConfiguration.intervalExtraLarge);
  //   } else if (res?.payload?.errors?.user_unauthorized?.[0]) {
  //     setTimeout(() => {
  //       navigate("/feature_not_assigned", {
  //         state: {
  //           unavailableService: "AReimbursementTxn",
  //         },
  //       });
  //     }, IntervalConfiguration.intervalExtraLarge);
  //   } else if (
  //     res?.payload?.status === false ||
  //     res.type === "beneTxnWaitingApproval/rejected"
  //   ) {
  //     if (
  //       res?.payload?.errors?.base[0]?.errors &&
  //       res?.payload?.errors?.base[0]?.errors[0]?.reason
  //     ) {
  //       const error_msg = res?.payload?.errors?.base[0]?.errors[0]?.reason;
  //       if (!Array.isArray(error_msg)) {
  //         setErrorMessage(error_msg);
  //         setTimeout(() => {
  //           CommonToast({
  //             text: error_msg,
  //             icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
  //             variant: "var(--error)",
  //             btnProps: {
  //               isDisabled: false,
  //               enabledTextColor: "var(--text-primary)",
  //               enabledBgColor: "var(--primary-bg)",
  //             },
  //           });
  //         }, IntervalConfiguration.intervalLarge);
  //       } else {
  //         setErrorMessage(res.payload.errors.base[0].errors[0].reason[0]);
  //         if (
  //           res.payload.errors.base[0].errors[0].reason.length >=
  //           GlobalConfiguration.lengthCheckOne
  //         ) {
  //           let msgs = res.payload.errors.base[0].errors[0].reason;
  //           msgs.forEach((error) => {
  //             if (res?.payload?.status === false) {
  //               setTimeout(() => {
  //                 CommonToast({
  //                   text: error,
  //                   icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
  //                   variant: "var(--error)",
  //                   btnProps: {
  //                     isDisabled: false,
  //                     enabledTextColor: "var(--text-primary)",
  //                     enabledBgColor: "var(--primary-bg)",
  //                   },
  //                 });
  //               }, IntervalConfiguration.intervalMedium);
  //             }
  //           });
  //         }
  //       }
  //     } else if (
  //       res?.payload?.errors?.base[0]?.reason &&
  //       res?.payload?.errors?.base[0]?.reason[0]
  //     ) {
  //       setErrorMessage(res?.payload?.errors?.base[0]?.reason[0]);
  //       setTimeout(() => {
  //         CommonToast({
  //           text: res?.payload?.errors?.base[0]?.reason[0],
  //           icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
  //           variant: "var(--error)",
  //           btnProps: {
  //             isDisabled: false,
  //             enabledTextColor: "var(--text-primary)",
  //             enabledBgColor: "var(--primary-bg)",
  //           },
  //         });
  //       }, IntervalConfiguration.intervalMedium);
  //     } else if (res?.payload?.errors?.base[0]) {
  //       setErrorMessage(res.payload.errors.base[0]);
  //       setTimeout(() => {
  //         CommonToast({
  //           text: res.payload.errors.base[0],
  //           icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
  //           variant: "var(--error)",
  //           btnProps: {
  //             isDisabled: false,
  //             enabledTextColor: "var(--text-primary)",
  //             enabledBgColor: "var(--primary-bg)",
  //           },
  //         });
  //       }, IntervalConfiguration.intervalExtraLarge);
  //     }
  //   } else {
  //     const updatedData = ReimbursementTxnAccountData?.transaction?.map(
  //       (data) => {
  //         return {
  //           ...data,
  //           lifecycle_status: res?.payload?.transactions[0]?.lifecycle_status,
  //           last_updated_status:
  //             res?.payload?.transactions[0]?.last_updated_status,
  //           last_updated_user_id:
  //             res?.payload?.transactions[0]?.last_updated_user_id,
  //         };
  //       },
  //     );
  //     setViewTxnDetails(updatedData);

  //     await dispatch(setDetailDataToApprovalData());

  //     if (res?.payload?.status === true) {

  //         CommonToast({
  //           text: "Transaction approved successfully.",
  //           icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
  //           variant: "var(--success)",
  //           btnProps: {
  //             isDisabled: false,
  //             enabledTextColor: "var(--text-primary)",
  //             enabledBgColor: "var(--primary-bg)",
  //           },
  //         });
  //       if (typeMulti === "MultiApproval_Session_Data") {
  //         let storedData = JSON.parse(
  //           sessionStorage.getItem("selectedReimbursementTxnData"),
  //         );

  //         if (storedData) {
  //           const updatedTransactions =
  //             storedData.selectedSendTransactions.filter(
  //               (transaction) => transaction.txn_id !== bene_txn_id,
  //             );
  //           const updatedTransactionsId =
  //             storedData.selectedTransactions.filter(
  //               (transaction) => transaction !== bene_txn_id,
  //             );

  //           sessionStorage.setItem(
  //             "selectedReimbursementTxnData",
  //             JSON.stringify({
  //               ...storedData,
  //               selectedSendTransactions: updatedTransactions,
  //               selectedTransactions: updatedTransactionsId,
  //             }),
  //           );
  //           setTransactionFilterData(updatedTransactions);
  //           setTransactionFilterID(updatedTransactionsId);
  //         }
  //       }

  //       if (type === "bene_txn_detail_modal") {
  //         setTimeout(() => {
  //           closeDetailModal?.();
  //           window.location.reload();
  //         }, IntervalConfiguration.intervalMedium);
  //       }
  //     }
  //   }
  // };
  const handleApproveTransaction = async (targetId) => {
    // Check account dependencies before transaction approval - matching accounts gate styling
    if (
      viewTxnDetails?.[0]?.beneficiary_account_approval_status === "pending"
    ) {
      CommonToast({
        text: "Please approve the associated beneficiary account first.",
        icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
        variant: "var(--error)",
      });
      return;
    }

    setShowLoader(true);
    UniversalRefreshToast("approveTxn");

    const response = await dispatch(ReimbursementTxnWaitingApproval(targetId));
    const payload = response?.payload;

    if (
      payload?.errors?.user_unauthorized?.length >
      GlobalConfiguration?.lengthCheckZero
    ) {
      navigate("/feature_not_assigned", {
        state: { unavailableService: "AReimbursementTxn" },
      });
      return;
    }

    // // Artificial timing window matching account details wrapper
    // await new Promise((resolve) => {
    //   setTimeout(resolve, IntervalConfiguration.intervalExtraLarge);
    // });

    if (
      response?.payload?.status === false ||
      response?.payload === undefined
    ) {
      let error_msg = "An error occurred while approving this transaction";
      if (payload?.errors?.base?.[0]?.errors?.[0]?.reason) {
        error_msg = payload.errors.base[0].errors[0].reason;
      } else if (payload?.errors?.base?.[0]) {
        error_msg = payload.errors.base[0];
      }
      const finalMsg = Array.isArray(error_msg) ? error_msg[0] : error_msg;

      const updatedData = viewTxnDetails.map((item) => {
        if (item.txn_id === targetId) {
          return { ...item, message: finalMsg, error: true };
        }
        return item;
      });
      setViewTxnDetails(updatedData);
      setShowLoader(false);
      setbtnClicked((prev) => ({ ...prev, [targetId]: "none" }));
      toast.dismiss();

      CommonToast({
        text: finalMsg,
        icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
        variant: "var(--error)",
      });
    } else {
      // Success State Unification
      const updatedData = viewTxnDetails.map((item) => {
        if (item.txn_id === targetId) {
          return {
            ...item,
            lifecycle_status:
              payload?.transactions?.[0]?.lifecycle_status || "approved",
            error: false,
          };
        }
        return item;
      });
      setViewTxnDetails(updatedData);
      setShowLoader(false);

      toast.dismiss();
      CommonToast({
        text: "Transaction approved successfully.",
        icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
        variant: "var(--success)",
      });

      // Handle session array filtration mapping accurately cleanly using targetId parameter
      if (typeMulti === "MultiApproval_Session_Data") {
        let storedData = JSON.parse(
          sessionStorage.getItem("selectedReimbursementTxnData"),
        );
        if (storedData) {
          const updatedTransactions =
            storedData.selectedSendTransactions.filter(
              (t) => t.txn_id !== targetId,
            );
          const updatedTransactionIds = storedData.selectedTransactions.filter(
            (id) => id !== targetId,
          );
          sessionStorage.setItem(
            "selectedReimbursementTxnData",
            JSON.stringify({
              ...storedData,
              selectedSendTransactions: updatedTransactions,
              selectedTransactions: updatedTransactionIds,
            }),
          );
          setTransactionFilterData(updatedTransactions);
          setTransactionFilterID(updatedTransactionIds);
        }
      }

      if (type === "bene_txn_detail_modal") {
        setTimeout(() => {
          closeDetailModal?.();
          onApproveSuccess?.(targetId);
        }, IntervalConfiguration.intervalMedium);
      }
      dispatch(setDetailDataToApprovalData());
    }
  };
  const handleDeclinedDetails = (id) => {
    setbeneTxnDetailsId(id);
    setShowDeclineModal(true);
  };

  const closeBeneAccountDetailModal = () => {
    setBeneAccountDetailpop(false);
  };

  const closeReimburseTxnDetailsModal = () => {
    setTxnLabelFilter("");
    setHistoryPopup(false);
    setPopupCatName("");
  };

  const showAmountInfo = () => {
    setInfoBox(!infoBox);
  };

  const handleInputChange = (event) => {
    const value = event.target.value;

    const sanitizedValue = value
      .replace(/[^a-zA-Z0-9\s]/g, "")
      .replace(/^\s+/, "")
      .replace(/\s{2,}/g, " ");

    const limitedValue = sanitizedValue.slice(
      GlobalConfiguration.lengthCheckZero,
      RejectReasonLength.lengthOfDecline,
    );

    setDeclineReason(limitedValue);
  };

  const closeModal = () => {
    if (infoBox || showDeclineModal) {
      setInfoBox(false);
    }
  };

  const actionRestricted = () => {
    toast.dismiss();
    showRestrictedAction({
      path: `/reimbursement_transaction_dashboard/reimbursement_transaction_view_all/reimbursement_transaction_detail_page/${id}`,
    });
  };

  const additional_data =
    ReimbursementTxnAccountData?.transaction[0]?.additional_data;

  const validItems = additional_data?.data ? additional_data?.data : [];
  const attachments = validItems.filter(
    (obj) =>
      (obj.data_type.toLowerCase() === "hyperlink" ||
        obj.data_type === "File" ||
        obj.data_type === "upload") &&
      "value" in obj,
  );
  const loginid = JSON.parse(sessionStorage.getItem("response"));

  const handleDistributionClick = () => {
    if (type === "bene_txn_detail_modal") {
      actionRestricted();
    } else {
      SetopenTimelinePopup(true);
      setShowDistributionTimeline(true);
      if (!showDistributionTimeline) {
        setShowApprovalTimeline(false);
      }
      setOpenApprovalTimeline(false);
    }
  };

  //   const handleReject = async (id, reason) => {
  //     if (isSubmittingRef.current) return;
  //     isSubmittingRef.current = true;
  //     setShowDeclineModal(false);
  //     try {
  //       if (
  //         services?.find(
  //           (service) => service === "AReimbursementTxn" || service === "Admin",
  //         ) !== undefined
  //       ) {
  //         // Token Check
  //         if (!sessionStorage.getItem("q2p_token")) {
  //           return;
  //         }

  //         setShowLoader(true);

  //         const apiCall = ReimbursementTxnDeniedApproval({
  //           id,
  //           AccountIdData: reason,
  //         });

  //         const result = await dispatch(apiCall);
  //         const payload = result?.payload;

  //         // wait for loader animation
  //         await new Promise((resolve) =>
  //           setTimeout(resolve, IntervalConfiguration.intervalExtraLarge),
  //         );

  //         if (payload?.status === errorcode.errorFailed) {
  //           CommonToast({
  //             text: payload?.error || "Something went wrong",
  //             icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
  //             variant: "var(--error)",
  //             btnProps: {
  //               isDisabled: false,
  //               enabledTextColor: "var(--text-primary)",
  //               enabledBgColor: "var(--primary-bg)",
  //             },
  //           });
  //           return finalize();
  //         }

  //         if (payload?.errors?.user_unauthorized?.[0]) {
  //           navigate("/feature_not_assigned", {
  //             state: { unavailableService: "ABeneficiaryTxn, Admin" },
  //           });
  //           return finalize();
  //         }

  //         // SINGLE approval flow
  //         const updatedData = viewTxnDetails?.map((item) => {
  //           if (item.txn_id !== id) return item;

  //           const tx = payload?.transactions?.[0];
  //           let lifecycleStatus = "error";
  //           let errorMessage = "";

  //           // lifecycle status logic
  //           if (payload?.status === true) {
  //             lifecycleStatus =
  //               tx?.lifecycle_status === "rejected"
  //                 ? "rejected"
  //                 : tx?.lifecycle_status === "pending"
  //                   ? "pendingOne"
  //                   : "error";
  //             // fetchData();
  //           }

  //           if (payload?.errors?.base?.[0]?.errors) {
  //             const errors = payload.errors.base[0].errors;
  //             errorMessage = errors[0];

  //             errors.forEach((msg) => {
  //               if (payload?.status === false) {
  //                 CommonToast({
  //                   text: msg,
  //                   icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
  //                   variant: "var(--error)",
  //                   btnProps: {
  //                     isDisabled: false,
  //                     enabledTextColor: "var(--text-primary)",
  //                     enabledBgColor: "var(--primary-bg)",
  //                   },
  //                 });
  //               }
  //             });
  //           } else if (payload?.errors?.base?.[0]) {
  //             errorMessage = payload.errors.base[0];
  //           }

  //           return {
  //             ...item,
  //             lifecycle_status:
  //               item.lifecycle_status === "pending" && payload?.status === true
  //                 ? lifecycleStatus
  //                 : "error",
  //             rejected: true,
  //             rejection_reason: reason,
  //             error: payload?.status === false ? "true" : "false",
  //             message: payload?.status === false ? errorMessage : "",
  //           };
  //         });

  //         updateAllAccounts(updatedData);

  //         if (payload?.status === false) {
  //           const err =
  //             payload?.errors?.base?.[0]?.errors?.[0] ||
  //             payload?.errors?.base?.[0] ||
  //             "Error occurred";
  //           CommonToast({
  //             text: err,
  //             icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
  //             variant: "var(--error)",
  //             btnProps: {
  //               isDisabled: false,
  //               enabledTextColor: "var(--text-primary)",
  //               enabledBgColor: "var(--primary-bg)",
  //             },
  //           });
  //         } else {
  //           CommonToast({
  //             text: "Transaction rejected successfully.",
  //             icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
  //             variant: "var(--success)",
  //             btnProps: {
  //               isDisabled: false,
  //               enabledTextColor: "var(--text-primary)",
  //               enabledBgColor: "var(--primary-bg)",
  //             },
  //           });
  //         }

  //         if (typeMulti === "MultiApproval_Session_Data") {
  //           let storedData = JSON.parse(
  //             sessionStorage.getItem("selectedReimbursementTxnData"),
  //           );

  //           if (storedData) {
  //             const updatedTransactions =
  //               storedData.selectedSendTransactions?.filter(
  //                 (txn) => txn.txn_id !== id,
  //               );

  //             const updatedTransactionIds =
  //               storedData.selectedTransactions?.filter((txnId) => txnId !== id);

  //             sessionStorage.setItem(
  //               "selectedReimbursementTxnData",
  //               JSON.stringify({
  //                 ...storedData,
  //                 selectedSendTransactions: updatedTransactions,
  //                 selectedTransactions: updatedTransactionIds,
  //               }),
  //             );
  //             setTransactionFilterData(updatedTransactions);
  //             setTransactionFilterID(updatedTransactionIds);
  //           }
  //         }
  //         if (type === "bene_txn_detail_modal") {
  //           setTimeout(() => {
  //   closeDetailModal?.();
  //   onRejectSuccess?.();
  // }, IntervalConfiguration.intervalMedium);
  //         }

  //         dispatch(setDetailDataToRejectData(id));
  //         finalize();
  //       } else {
  //         navigate("/feature_not_assigned", {
  //           state: {
  //             unavailableService: "AReimbursementTxn, Admin",
  //           },
  //         });
  //       }
  //     } finally {
  //       isSubmittingRef.current = false;
  //     }
  //   };
  const handleReject = async (targetId, reason) => {
    if (isSubmittingRef.current) return;
    isSubmittingRef.current = true;
    setShowDeclineModal(false);
    setShowLoader(true);
    UniversalRefreshToast("internalTxn");

    const response = await dispatch(
      ReimbursementTxnDeniedApproval({ id: targetId, AccountIdData: reason }),
    );
    const payload = response?.payload;

    if (
      payload?.errors?.user_unauthorized?.length >
      GlobalConfiguration?.lengthCheckZero
    ) {
      navigate("/feature_not_assigned", {
        state: { unavailableService: "AReimbursementTxn" },
      });
      isSubmittingRef.current = false;
      return;
    }

    // await new Promise((resolve) => {
    //   setTimeout(resolve, IntervalConfiguration.intervalExtraLarge);
    // });

    if (payload?.status === false || response?.payload === undefined) {
      let error_msg = "An error occurred while rejecting this transaction";
      let error_list = null;

      if (payload?.errors?.base?.[0]?.errors) {
        error_list = payload.errors.base[0].errors;
        error_msg = payload.errors.base[0].errors[0];
      } else if (payload?.errors?.base?.[0]) {
        error_msg = payload.errors.base[0];
      }
      const finalMsg = Array.isArray(error_msg) ? error_msg[0] : error_msg;

      const updatedData = viewTxnDetails.map((item) => {
        if (item.txn_id === targetId) {
          return { ...item, message: finalMsg, error: true };
        }
        return item;
      });
      setViewTxnDetails(updatedData);
      setShowLoader(false);
      setDeclineReason("");
      setbtnClicked((prev) => ({ ...prev, [targetId]: "none" }));
      // Safe Error Multi-Toast sequence mirroring Account layout style loops
      if (
        Array.isArray(error_list) &&
        error_list.length > GlobalConfiguration?.lengthCheckOne
      ) {
        error_list.forEach((err) => {
          setTimeout(() => {
            CommonToast({
              text: err,
              icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
              variant: "var(--error)",
            });
          }, IntervalConfiguration?.intervalSmall);
        });
      } else {
        CommonToast({
          text: error_msg,
          icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
          variant: "var(--error)",
        });
      }
      isSubmittingRef.current = false;
    } else {
      // Success sequence matching account structure changes natively
      const updatedData = viewTxnDetails.map((item) => {
        if (item.txn_id === targetId) {
          return {
            ...item,
            lifecycle_status: "rejected",
            rejection_reason: reason,
            error: false,
          };
        }
        return item;
      });
      setViewTxnDetails(updatedData);
      setShowLoader(false);
      setDeclineReason("");

      toast.dismiss();
      CommonToast({
        text: "Transaction rejected successfully.",
        icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
        variant: "var(--success)",
      });

      if (typeMulti === "MultiApproval_Session_Data") {
        let storedData = JSON.parse(
          sessionStorage.getItem("selectedReimbursementTxnData"),
        );
        if (storedData) {
          const updatedTransactions =
            storedData.selectedSendTransactions.filter(
              (t) => t.txn_id !== targetId,
            );
          const updatedTransactionIds = storedData.selectedTransactions.filter(
            (id) => id !== targetId,
          );
          sessionStorage.setItem(
            "selectedReimbursementTxnData",
            JSON.stringify({
              ...storedData,
              selectedSendTransactions: updatedTransactions,
              selectedTransactions: updatedTransactionIds,
            }),
          );
          setTransactionFilterData(updatedTransactions);
          setTransactionFilterID(updatedTransactionIds);
        }
      }

      if (type === "bene_txn_detail_modal") {
        setTimeout(() => {
          closeDetailModal?.();
          onRejectSuccess?.(targetId);
        }, IntervalConfiguration.intervalMedium);
      }
      dispatch(setDetailDataToRejectData(targetId));
      isSubmittingRef.current = false;
    }
  };
  const handleApprovalTimeline = (index) => {
    setOpenApprovalTimeline((prevOpenDivs) => {
      if (!Array.isArray(prevOpenDivs)) {
        return [];
      }
      const newOpenDivs = [...prevOpenDivs];
      newOpenDivs[index] = !newOpenDivs[index];
      return newOpenDivs;
    });
    setOpenDistributionTimeline(
      Array(viewTxnDetails?.[0]?.distribution_logs?.length).fill(false),
    );
    if (!openApprovalTimeline[index]) {
      setTimeout(() => {
        cardRefs.current[index]?.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      }, IntervalConfiguration.intervalExtraSmall);
    }
  };

  const handleDistributionTimeline = (index) => {
    setOpenDistributionTimeline((prevOpenDivs) => {
      if (!Array.isArray(prevOpenDivs)) {
        return [];
      }
      const newOpenDivs = [...prevOpenDivs];
      newOpenDivs[index] = !newOpenDivs[index];
      return newOpenDivs;
    });
    setTimeout(() => {
      if (cardRefsDist.current[index]) {
        cardRefsDist.current[index].scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      }
    }, IntervalConfiguration.intervalExtraSmall);
  };

  const handleAssignLabelsProp = async (labelsToAssign, whichToast = "new") => {
    const toArray = (value) => (Array?.isArray(value) ? value : [value]);

    // Optimistic Update
    setLabelDetails((prev) => [
      ...new Set([...(prev || []), ...labelsToAssign]),
    ]);

    const res = await dispatch(
      addReimbursementTxnLabel({
        record_ids: toArray(id),
        labels: labelsToAssign,
      }),
    );

    if (addReimbursementTxnLabel.fulfilled.match(res)) {
      fetchData(true); // Silent refresh
      toast.dismiss();
      CommonToast({
        text:
          whichToast === "new"
            ? "New label assigned successfully."
            : "Labels assigned successfully.",
        icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
        variant: "var(--success)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
      if (labelActionDispatchedRef) labelActionDispatchedRef.current = true;
    }

    if (addReimbursementTxnLabel.rejected.match(res)) {
      fetchData(true);
    }

    return addReimbursementTxnLabel?.fulfilled?.match(res) ? true : false;
  };

  const handleUnassignLabelsProp = async (labelsToUnassign) => {
    const toArray = (value) => (Array.isArray(value) ? value : [value]);

    // Optimistic Update
    setLabelDetails((prev) =>
      (prev || []).filter((l) => !labelsToUnassign.includes(l)),
    );

    const res = await dispatch(
      removeReimbursementTxnLabel({
        record_ids: toArray(id),
        labels: labelsToUnassign,
      }),
    );

    if (removeReimbursementTxnLabel.fulfilled.match(res)) {
      fetchData(true); // Silent refresh
      toast.dismiss();
      CommonToast({
        text: "Labels unassigned successfully.",
        icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
        variant: "var(--success)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
      if (labelActionDispatchedRef) labelActionDispatchedRef.current = true;
    }

    if (removeReimbursementTxnLabel.rejected.match(res)) {
      fetchData(true); // Re-sync in case of failure
    }

    return removeReimbursementTxnLabel?.fulfilled?.match(res) ? true : false;
  };

  useLayoutEffect(() => {
    if (index !== prevIndex) {
      const direction =
        index > prevIndex ? "animate-slide-next" : "animate-slide-prev";

      setAnimationClass(direction);
      setPrevIndex(index);
    }
  }, [index]);

  useEffect(() => {
    fetchData();
  }, [id]);
  const categoryIcon = categoryMapper(
    viewTxnDetails[0]?.category_id?.category_id,
  );
  useEffect(() => {
    if (ReimbursementTxnAccountData) {
      const uiState = addLifeCycleStatus({
        lifecycle_status:
          ReimbursementTxnAccountData?.transaction[0]?.lifecycle_status,
        distribution_lifecycle_status:
          ReimbursementTxnAccountData?.transaction[0]
            ?.distribution_lifecycle_status,
        services,
      });
      const newData = ReimbursementTxnAccountData?.transaction?.map(
        (account) => ({
          ...account,
          loading: false,
          error: false,
          message: "",
          last_updated_user_id_check: false,
          ...uiState,
        }),
      );
      setViewTxnDetails(newData);
      setbeneTxnDetailsId(idFromParams);
    }
  }, [ReimbursementTxnAccountData]);

  useEffect(() => {
    const entityId = ReimbursementTxnAccountData?.transaction?.[0]?.entity_id;
    const lifecycleStatus =
      ReimbursementTxnAccountData?.transaction?.[0]?.lifecycle_status;

    const canCheckActionable =
      entityId &&
      beneTxnDetailsId &&
      lifecycleStatus === "pending" &&
      services?.includes("AReimbursementTxn");

    if (!canCheckActionable) {
      return;
    }

    const checkTxnActionable = async () => {
      setLoadingBox(true);
      try {
        const response = await dispatch(
          reimbursementTxnApproval({
            entityId,
            txn_id: beneTxnDetailsId,
          }),
        );

        const transactionsData = response?.payload?.transactions ?? [];

        const transactionExists = transactionsData.some(
          (obj) => String(obj.txn_id) === String(beneTxnDetailsId),
        );

        setCheckTransaction(transactionExists);

        if (!transactionExists) {
          setApprovalNotPermitted(true);
        }
      } catch (error) {
        setCheckTransaction(false);
      } finally {
        setLoadingBox(false);
      }
    };
    checkTxnActionable();
  }, [
    dispatch,
    beneTxnDetailsId,
    ReimbursementTxnAccountData?.transaction?.[0]?.entity_id,
    ReimbursementTxnAccountData?.transaction?.[0]?.lifecycle_status,
    services,
  ]);
  return (
    <>
      {showBanner && (
        <div
          className="fixed top-left-base left-left-base w-screen h-screen z-z-index-max bg-PopUp-BackDrop bg-opacity-dark-opacity"
          onClick={() => setShowBanner(false)}
        >
          <SmallPopupWithBulletPoints
            headerTitle={"Why transaction cannot be processed?"}
            headIconColor="var(--text-primary)"
            closeIconImage={ICONS?.CLOSE}
            closeModal={() => setShowBanner(false)}
            headerFontWeight="semibold"
            headerFontColor="text-primary"
            textSize="font-md"
            secondHeaderFontWeight="semibold"
            bulletPoints={[
              `Any transaction created or approved after banking hours i.e. between ${outsideBankingHoursLabel} will be processed on the next bank working day.`,
              "Payments are time-critical (e.g., salary, vendor payment, or bill payment), consider the possible processing delay before proceeding.",
            ]}
          />
        </div>
      )}
      <>{RestrictedActionPopup}</>
      {showLabelsPopup && (
        <div
          onClick={(e) => {
            e.stopPropagation();
            setShowLabelsPopup(true);
          }}
          className="fixed left-left-base w-width-full top-top-base h-height-full bg-PopUp-BackDrop bg-opacity-dark-opacity flex items-center justify-center z-z-index-modal"
        >
          <CommonAssignLabelPopup
            headerTitle="Assign/Unassign labels:"
            headersubtext="Labels will be used to generate statistics for the associated reimbursement transactions."
            closehandleFunction={handleClose}
            closeisDisabled={false}
            labels={labels}
            setLabels={setLabels}
            LabelAccounts={id}
            isLabelPopupOpen={showLabelsPopup}
            filteredData={ReimbursementTxnAccountData?.transaction?.map(
              (t) => ({ ...t, labels: labelDetails }),
            )}
            labelActionDispatchedRef={labelActionDispatchedRef}
            onClose={handleClose}
            loading={labelPopupLoading}
            setLoading={setLabelPopupLoading}
            handleAssignLabels={handleAssignLabelsProp}
            handleUnassignLabels={handleUnassignLabelsProp}
            type="details"
          />
        </div>
      )}

      {historyPopup && (
        <>
          <div className="fixed top-top-base left-left-base w-width-full h-height-full flex items-center bg-PopUp-BackDrop justify-center z-z-index-modal bg-opacity-dark-opacity">
            <ReimbursementTxnViewAllPopup
              closeReimburseTxnDetailsModal={closeReimburseTxnDetailsModal}
              TxnHistoryid={txnHistoryId}
              popupCatName={popupCatName}
              TxnHistoryAccountName={txnHistoryAccountName}
              categoryName={categoryName}
              txnLabelfilter={txnLabelfilter ? [txnLabelfilter] : []}
              type={"reimburse_txnViewAll_popup"}
              // HistoryPopup={historyPopup}
              flow={
                categoryName.length
                  ? ""
                  : txnLabelfilter
                    ? "txnLabelfilterhistory"
                    : "history"
              }
            />
          </div>
        </>
      )}

      {openImageUrl && (
        <>
          <div className="fixed top-top-base left-left-base w-width-full h-height-full flex items-center bg-PopUp-BackDrop justify-center z-z-index-modal bg-opacity-dark-opacity">
            <MediumImagePopup
              image={selectedImage}
              closehandleFunction={() => {
                setOpenImageUrl(false);
              }}
            />
          </div>
        </>
      )}

      {opentimelinepopup && (
        <>
          <div className="fixed top-top-base left-left-base w-width-full h-height-full flex items-center bg-PopUp-BackDrop justify-center z-z-index-modal bg-opacity-dark-opacity">
            <LargePopupRedirect
              headerTitle="Transaction timeline"
              headerFontWeight="semibold"
              headerFontColor="text-primary"
              headertextSize="font-md"
              closeiconenabledBgColor="var(--primary-nav)"
              closeiconisLoading={false}
              closeiconhandleFunction={popupcloseIcons}
              closeicon={ICONS?.CLOSE}
              closeiconhoverOption="white"
              closeiconbtnType={"button"}
              closeiconisDisabled={false}
              closeicondisabledBgColor={""}
              closeiconbuttonRef={null}
              closeicontitle={"Close"}
              btnType={"button"}
              handleFunction={() => {}}
              enabledBgColor={"var(--positive-act)"}
              hoverOption={"dark"}
              outLineColor={""}
              enabledTextColor={"var(--text-primary)"}
              fullWidthRequired={false}
              isDisabled={false}
              disabledTextColor={""}
              disabledBgColor={""}
              isLoading={false}
              buttonRef={null}
              inActiveVariantNeeded={false}
              isLoaderNeeded={false}
              isscrollRequired={true}
            >
              <TimelinePopupContent
                logsData={viewTxnDetails}
                handleApprovalClick={handleTimelinePopup}
                handleDistributionClick={handleDistributionClick}
                showDistributionRightIcon={false}
                showApprovalLeftIcon={false}
                showApprovalTimeline={showApprovalTimeline}
                openApprovalTimeline={openApprovalTimeline}
                handleApprovalTimeline={handleApprovalTimeline}
                showDistributionTimeline={showDistributionTimeline}
                openDistributionTimeline={openDistributionTimeline}
                handleDistributionTimeline={handleDistributionTimeline}
                setOpenDistributionTimeline={setOpenDistributionTimeline}
                setOpenApprovalTimeline={setOpenApprovalTimeline}
                cardType={"double"}
                popUpMode={true}
              />
            </LargePopupRedirect>
          </div>
        </>
      )}
      {alertPopUp && (
        <div className="fixed top-top-base left-left-base w-width-full h-height-full flex items-center bg-Primary-black justify-center z-z-index-max bg-opacity-dark-opacity">
          <FullScreen
            type={"txn"}
            id={bene_txn_id}
            setAlertPopUp={setAlertPopUp}
          />
        </div>
      )}
      <div
        className={`bg-primary-bg overflow-x-hidden ${showDeclineModal ? "overflow-y-hidden" : "overflow-y-auto"}`}
        style={{
          height:
            type === "bene_txn_detail_modal"
              ? "var(--height-full)"
              : "var(--full-height)",
        }}
        onClick={closeModal}
      >
        {loading ? (
          <div className="bene-detail-loader-box m-auto justify-center items-center flex">
            <Loader />
          </div>
        ) : (
          <>
            {type !== "bene_txn_detail_modal" ? (
              <div className="Qsmd:flex hidden h-navbar-breadcrumb-height bg-primary-nav w-width-full"></div>
            ) : null}

            <div
              className={`beneTxnDetailsPage ${
                type === "bene_txn_detail_modal" ? "" : ""
              }`}
            >
              {showDeclineModal && (
                <div
                  className="fixed top-top-base left-left-base w-full h-full bg-PopUp-BackDrop bg-opacity-dark-opacity flex items-center justify-center z-z-index-modal"
                  onClick={(e) => e.stopPropagation()}
                >
                  <SmallPopupWithInput
                    headerTitle={"Reject transaction"}
                    headerFontWeight="semibold"
                    headerFontColor="text-primary"
                    textSize="font-md"
                    subtextwithbullet="Y"
                    secondHeaderTitle={"Provide the reason for rejection."}
                    secondHeaderFontWeight="normal"
                    noteText="Minimum 10 characters required."
                    secondHeaderFontColor="text-secondary"
                    bulletPoints={[
                      "Transaction will be rejected, and distribution will not be initiated.",
                      "Transaction cannot be edited.",
                    ]}
                    secondHeaderTextSize="font-xs"
                    inputPlaceholder={"Reason"}
                    inputVariant={computeVariant(declineReason, isFocused)}
                    inputOnFocus={(e) => setIsFocused(true)}
                    inputOnBlur={(e) => setIsFocused(false)}
                    inputBgColor="var(--primary-bg)"
                    inputFgColor="var(--text-secondary)"
                    inputOnInput={(e) => {
                      if (!showLoader) {
                        handleInputChange(e);
                      }
                    }}
                    inputValue={declineReason}
                    inputFontKind="big"
                    inputIsFullWidth={true}
                    btnOneText={TEXT.CANCEL}
                    btnOneHandleFunction={() => {
                      if (!showLoader) {
                        setShowDeclineModal(false);
                        setDeclineReason("");

                        setbtnClicked((prev) => ({
                          ...prev,
                          [viewTxnDetails?.[0]?.txn_id]: "none",
                        }));
                      }
                    }}
                    btnOneEnabledBgColor="var(--primary-bg)"
                    btnOneOutLineColor="var(--text-primary)"
                    btnOneEnabledTextColor="var(--text-primary)"
                    btnOneHoverOption="white"
                    btnOneIsDisabled={showLoader}
                    btnTwoText={TEXT.REJECT}
                    btnTwoHandleFunction={() => {
                      if (
                        !declineReason ||
                        declineReason.length <
                          GlobalConfiguration.owneraccountnormalLength ||
                        showLoader
                      ) {
                        return;
                      }
                      handleReject(beneTxnDetailsId, declineReason);
                    }}
                    btnTwoEnabledBgColor="var(--negative-act)"
                    btnTwoEnabledTextColor="var(--text-primary)"
                    btnTwoIsDisabled={
                      !declineReason ||
                      declineReason.length <
                        GlobalConfiguration.owneraccountnormalLength
                    }
                    btnTwoDisabledBgColor="var(--text-disabled)"
                    btnTwoIsLoaderNeeded={showLoader ? true : false}
                    btnTwoIsLoading={showLoader ? true : false}
                    btnTwoHoverOption="black"
                    btnTwoInActiveVariantNeeded={true}
                  />
                </div>
              )}

              {beneAccountDetailpop && (
                <div className="fixed top-top-base left-left-base w-screen h-screen z-z-index-modal bg-Primary-black bg-opacity-dark-opacity">
                  <ReimbursementAccountDetailsPopup
                    closeBeneAccountDetailModal={closeBeneAccountDetailModal}
                    reimburse_account_id={bene_account_id}
                    type={"reimburseacc_details"}
                  />
                </div>
              )}

              {ownerDetailpop && (
                <div className="fixed top-top-base left-left-base w-screen h-screen z-z-index-modal bg-Primary-black bg-opacity-dark-opacity">
                  <OwnerAccountDetailsPopUp
                    closeBeneAccountDetailModal={() => {
                      setOwnerDetailpop(false);
                    }}
                    Remibursement_owneraccount_id={
                      ReimbursementTxnAccountData?.transaction?.[0]
                        ?.owner_account_id
                    }
                    type={"reimburseowner_details"}
                  />
                </div>
              )}

              <div
                className={`fixed top-top-base left-left-base mt-margin-base w-width-full z-z-index-header bg-primary-nav shadow-box-shadow-bottom ${
                  type === "bene_txn_detail_modal" ? "hidden" : "lg:hidden"
                } block`}
              >
                <TopNavComponent
                  isFormattingNotRequired={true}
                  topNavHeader={"Reimbursement"}
                  topNavSubText="Transaction details"
                />
              </div>
              <div
                className={`h-auto w-width-full bg-primary-nav Qsmd:pt-padding-base  ${type === "bene-txn-detail-modal" ? "pt-padding-base" : "pt-padding-md"}`}
              >
                <div
                  className={`bene-txn-account-primary-details  ${type === "bene_txn_detail_modal" ? "" : "Qsmd:pt-padding-base pt-padding-xl"} `}
                >
                  {ReimbursementTxnAccountData?.transaction?.map((account) => {
                    const categoryIcon = categoryMapper(
                      account?.category_id?.category_id,
                    );
                    return (
                      <div
                        key={account.txn_id}
                        className={`w-width-full h-auto bg-primary-nav ${
                          type === "bene_txn_detail_modal"
                        }`}
                      >
                        <div
                          className={`flex flex-col lg:flex-row  border-solid border-primary-bg border-b mx-margin-md lg:mx-margin-base`}
                        >
                          <div
                            className={`${type === "bene_txn_detail_modal" ? "lg:w-width-md" : "lg:w-width-md w-auto"} Qlg:px-padding-base justify-between flex flex-row gap-x-gap-sm items-center py-padding-md    Qlg:flex-shrink-0 flex-1 `}
                          >
                            <div className="flex flex-col justify-start gap-y-gap-xs lg:pl-padding-sm">
                              <div className="flex flex-row gap-x-gap-xs relative">
                                <div>
                                  <TitleSubtitlePair
                                    title={`INR ${formatCurrency(account.total_amount)}`}
                                    titleColor="settled"
                                    subtitle="Amount"
                                    info={true}
                                    onClick={showAmountInfo}
                                    alignRight={false}
                                    hoverOption="white"
                                    isBold={true}
                                    variant="md"
                                  />
                                </div>

                                {infoBox && (
                                  <div className="fixed top-top-base left-left-base w-width-full h-height-full flex items-center bg-PopUp-BackDrop justify-center z-z-index-modal bg-opacity-dark-opacity">
                                    <CommonInfoBox
                                      headerTitle="Amount Breakdown"
                                      transactionAmount={account.total_amount}
                                      transactionAmountColor={"settled"}
                                      transactionLabel="Transaction amount"
                                      finalAmountLabel="Amount credited"
                                      rows={[
                                        {
                                          label: "Amount debited",
                                          value: account.total_amount,
                                          icon: ICONS?.SUBTRACTION_WITH_ROUNDNESS,
                                        },
                                        {
                                          label: "Tax amount",
                                          value: account.tax_amount,
                                          icon: ICONS?.SUBTRACTION_WITH_ROUNDNESS,

                                          operation: "subtract",
                                        },
                                        {
                                          label: "Payment charge",
                                          value: account.payment_charge,

                                          operation: "subtract",
                                        },
                                      ]}
                                      headerFontColor="text-primary"
                                      headerFontWeight="semibold"
                                      textSize="font-md"
                                      onClosepop={() => setInfoBox(null)}
                                      popupBgColor="primary-bg"
                                    />
                                  </div>
                                )}
                              </div>
                            </div>
                            <div className="lg:mr-margin-md flex justify-end mr-margin-base gap-y-gap-xs text-right min-w-0 break-all flex-wrap">
                              <TitleSubtitlePair
                                isDisabled={false}
                                alignRight={true}
                                title={
                                  account.distribution_utr
                                    ? account.distribution_utr
                                    : "N/A"
                                }
                                titleColor={"text-primary"}
                                subtitle={TEXT?.UTR_NUMBER}
                                info={false}
                                showArrow={false}
                                isBold={false}
                                variant={"md"}
                                textAlign="right"
                              />
                            </div>
                          </div>

                          <div className="border-r border-solid border-primary-bg my-margin-md hidden lg:block"></div>
                          <div className="flex flex-row justify-between items-center lg:justify-start gap-x-gap-md w-width-full lg:w-width-md py-padding-md lg:py-padding-md Qmd:px-padding-base lg:px-padding-base border-t lg:border-none border-solid border-primary-bg flex-1 px-padding-base">
                            <div className="gap-y-gap-xs lg:pl-padding-md">
                              <div>
                                <TitleSubtitlePair
                                  title={account.beneficiary_account_name}
                                  titleColor="text-primary"
                                  subtitle={"Account name"}
                                  info={false}
                                  alignRight={false}
                                  hoverOption="white"
                                  isBold={false}
                                  variant="md"
                                />
                              </div>
                            </div>
                          </div>
                          {/* <div
                            className=" hidden  lg:block"
                            style={{
                              visibility: "hidden",
                            }}
                          >
                            <TopNavSmallButton
                              btnType="button"
                              isDisabled={type === "bene_txn_detail_modal"}
                              enabledTextColor="var(--text-primary)"
                              enabledBgColor="var(--primary-nav-act)"
                              disabledBgColor="var(--primary-nav-act)"
                              hoverOption="white"
                              fullWidthRequired={false}
                            />
                          </div> */}
                          <div className=" hidden lg:block border-primary-bg">
                            <TopNavSmallButton
                              btnText={
                                <>
                                  Linked
                                  <br />
                                  request
                                </>
                              }
                              btnType="button"
                              icon={ICONS?.LINKED_WHITE_CIRCLE}
                              handleFunction={() => {
                                if (type === "bene_txn_detail_modal") {
                                  actionRestricted();
                                } else if (account?.reimbursement_request_id) {
                                  navigate(
                                    `/reimbursement_transaction_dashboard/reimbursement_request_view_all/reimbursement_request_detail_page/${account?.reimbursement_request_id}`,
                                  );
                                } else {
                                  return;
                                }
                              }}
                              isDisabled={
                                type === "bene_txn_detail_modal"
                                  ? true
                                  : !account?.reimbursement_request_id
                                    ? true
                                    : false
                              }
                              enabledTextColor="var(--text-primary)"
                              enabledBgColor="var(--primary-nav-act)"
                              disabledBgColor="var(--primary-nav-act)"
                              hoverOption="white"
                              fullWidthRequired={false}
                            />
                          </div>
                        </div>

                        <div className="relative">
                          <div className="flex flex-col justify-between lg:flex-row lg:gap-gap-base h-auto lg:h-auto w-width-full">
                            <div
                              className={`flex flex-col pt-padding-sm w-width-full lg:w-width-md justify-between lg:h-height-md ${type === "bene_txn_detail_modal" ? "  pl-padding-sm pr-padding-md lg:px-padding-base pt-padding-base Qlg:pr-padding-base " : "lg:pl-padding-base lg:pr-padding-base"} px-padding-base`}
                            >
                              <div className="flex w-full justify-between items-center pb-padding-sm">
                                {" "}
                                <div
                                  className={`${
                                    !services?.includes("VAccount") ||
                                    type === "bene_txn_detail_modal"
                                      ? " pl-padding-base pb-padding-base"
                                      : "pl-padding-sm lg:pl-padding-base"
                                  }`}
                                >
                                  <TitleSubtitlePair
                                    isDisabled={
                                      type === "bene_txn_detail_modal" ||
                                      !services?.includes("VAccount")
                                        ? true
                                        : false
                                    }
                                    alignRight={false}
                                    title={formatAccountNumber(
                                      account?.owner_account_bank_acc_no,
                                    )}
                                    titleColor={"text-primary"}
                                    subtitle={TEXT?.SOURCE_ACCOUNT}
                                    onClick={() => {
                                      if (!services?.includes("VAccount")) {
                                        navigate("/feature_not_assigned", {
                                          state: {
                                            unavailableService: "VAccount",
                                          },
                                        });
                                        return; // stop execution
                                      }

                                      // 2. Action based on type
                                      if (type === "bene_txn_detail_modal") {
                                        actionRestricted();
                                      } else {
                                        setOwnerDetailpop(true);
                                      }
                                    }}
                                    info={false}
                                    showArrow={true}
                                    hoverOption={"white"}
                                    isBold={false}
                                    variant={"md"}
                                  />
                                </div>
                                <div
                                  className={`${type === "bene_txn_detail_modal" ? "mr-margin-base lg:mr-margin-md" : "mr-margin-md"}`}
                                >
                                  <CommonBankLogo
                                    ifsc={account.owner_account_ifsc_code}
                                    variant="big"
                                    type="pill"
                                  />
                                </div>
                              </div>

                              <div
                                className={` block lg:hidden border-t border-primary-bg pt-padding-md mb-margin-sm lg:mb-margin-base ${type === "bene_txn_detail_modal" ? "ml-margin-sm" : "mx-margin-md"} `}
                              >
                                <TitleSubtitlePair
                                  isDisabled={false}
                                  alignRight={false}
                                  title={account?.owner_account_ifsc_code}
                                  titleColor={"text-primary"}
                                  subtitle={TEXT?.IFSC}
                                  info={false}
                                  showArrow={false}
                                  isBold={false}
                                  variant={"md"}
                                />
                              </div>
                            </div>

                            <div className="flex items-center gap-gap-sm justify-start Qlg:px-padding-md lg:hidden mx-margin-md Qlg:mx-margin-base">
                              <div className="w-width-md border-b border-primary-bg"></div>
                              <div className="w-icon-md">
                                <img
                                  src={ICONS?.ARROW_DOWN_BLUE_WHITE}
                                  alt="arrowDownBlueWhite"
                                />
                              </div>
                              <div className="w-width-md border-b border-primary-bg"></div>
                            </div>

                            <div
                              className={`border-r border-solid border-primary-bg  h-auto my-margin-lg hidden lg:block ${type === "bene_txn_detail_modal" ? "mt-margin-sm" : "mt-margin-md"}`}
                            ></div>

                            <div className="flex flex-row justify-between Qlg:gap-gap-base gap-gap-xl pr-padding-base w-width-full lg:w-width-md">
                              <div className="w-width-full flex justify-between Qlg:gap-gap-base gap-gap-md">
                                <div
                                  className={`flex flex-col lg:pt-padding-sm pb-padding-md lg:pb-padding-base w-width-full justify-between lg:px-padding-base gap-gap-sm ${type === "bene_txn_detail_modal" ? "lg:pl-padding-base px-padding-sm " : "lg:pl-padding-sm"}`}
                                >
                                  <div className="flex items-center justify-between w-full Qsmd:items-center">
                                    <div
                                      className={`${type === "bene_txn_detail_modal" ? "lg:ml-margin-sm " : " lg:ml-margin-base pl-padding-sm lg:pl-padding-base"} `}
                                    >
                                      <TitleSubtitlePair
                                        isDisabled={
                                          type === "bene_txn_detail_modal"
                                            ? true
                                            : false
                                        }
                                        alignRight={false}
                                        title={formatAccountNumber(
                                          account?.beneficiary_account_bank_acc_no,
                                        )}
                                        titleColor={"text-primary"}
                                        subtitle={"Destination account"}
                                        onClick={() => {
                                          if (
                                            type === "bene_txn_detail_modal"
                                          ) {
                                            actionRestricted();
                                          } else {
                                            setBeneAccountDetailpop(true);
                                          }
                                        }}
                                        info={false}
                                        showArrow={true}
                                        hoverOption={"white"}
                                        isBold={false}
                                        variant={"md"}
                                      />
                                    </div>
                                    <div
                                      className={`${type === "bene_txn_detail_modal" ? "mr-margin-sm lg:mr-margin-md" : "mr-margin-md"}`}
                                    >
                                      <CommonBankLogo
                                        ifsc={
                                          account.beneficiary_account_ifsc_code
                                        }
                                        variant="big"
                                        type="pill"
                                      />
                                    </div>
                                  </div>
                                  <div
                                    className={` block  lg:hidden border-t border-primary-bg pt-padding-md ${type === "bene_txn_detail_modal" ? "mx-margin-sm" : "mx-margin-md"} `}
                                  >
                                    <TitleSubtitlePair
                                      isDisabled={false}
                                      alignRight={false}
                                      title={
                                        account.beneficiary_account_ifsc_code
                                      }
                                      titleColor={"text-primary"}
                                      subtitle={TEXT?.IFSC}
                                      info={false}
                                      showArrow={false}
                                      isBold={false}
                                      variant={"md"}
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div
                              className="hidden lg:flex flex-col justify-end gap-gap-base mr-margin_margin-md ml-margin-base"
                              style={{
                                width:
                                  "calc(var(--positive-negative-btn-width))",
                              }}
                            >
                              <div
                                className={`lg:flex flex-row overflow-hidden justify-end h-full w-auto`}
                                style={{
                                  width: "calc(var(--topnav-small-btn-width))",
                                }}
                              >
                                <div className="border-b solid border-primary-bg">
                                  <TopNavSmallButton
                                    btnText={
                                      <>
                                        {TEXT?.TRANSACTION}
                                        <br />
                                        {TEXT?.HISTORY}
                                      </>
                                    }
                                    btnType="button"
                                    icon={ICONS?.TRANSACTION_HISTORY}
                                    handleFunction={() => {
                                      if (type === "bene_txn_detail_modal") {
                                        actionRestricted();
                                      } else {
                                        setHistoryPopup(true);
                                        setTxnHistoryId(
                                          account?.beneficiary_account_id,
                                        );
                                        setTxnHistoryAccountName(
                                          account?.beneficiary_account_name,
                                        );
                                        setcategoryName("");
                                      }
                                    }}
                                    isDisabled={
                                      type === "bene_txn_detail_modal"
                                    }
                                    enabledTextColor="var(--text-primary)"
                                    enabledBgColor="var(--primary-nav-act)"
                                    disabledBgColor="var(--primary-nav-act)"
                                    hoverOption="white"
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="border-primary-bg border-solid border-t flex flex-col h-auto items-center justify-between lg:border-none lg:flex-col lg:px-padding-base lg:w-width-full mx-margin-md lg:mx-margin-base">
                          <div className="flex flex-row h-auto items-center justify-between lg:border-none lg:flex-row lg:px-padding-base w-width-full Qmd:h-positive-negative-btn-height">
                            <div className="w-width-full flex flex-row h-auto items-center justify-between lg:border-none lg:flex-row lg:px-padding-base   relative">
                              <div className="parent flex flex-row py-padding-md lg:py-padding-base w-full Qlg:w-width-md lg:justify-between justify-end gap-gap-sm">
                                <div className="lg:flex flex-col gap-y-gap-xs hidden mr-margin-xl lg:pl-padding-sm">
                                  <TitleSubtitlePair
                                    isDisabled={false}
                                    alignRight={false}
                                    title={account?.owner_account_ifsc_code}
                                    titleColor={"text-primary"}
                                    subtitle={TEXT?.IFSC}
                                    info={false}
                                    showArrow={false}
                                    isBold={false}
                                    variant={"md"}
                                  />
                                </div>

                                <div className="Qlg:hidden payment flex flex-col gap-y-gap-xs item-start ml-margin-lg mr-margin-md">
                                  <TitleSubtitlePair
                                    isDisabled={false}
                                    alignRight={false}
                                    title={
                                      account.distribution_mode_of_payment ||
                                      account.payment_method ||
                                      "N/A"
                                    }
                                    titleColor={"text-primary"}
                                    subtitle={TEXT?.PAYMENT_METHOD}
                                    info={false}
                                    showArrow={false}
                                    isBold={false}
                                    variant={"md"}
                                  />
                                </div>
                                <div className=" hidden Qlg:flex flex-col gap-y-gap-xs items-end item-start  mr-margin-md">
                                  <TitleSubtitlePair
                                    isDisabled={false}
                                    alignRight={true}
                                    textAlign={"right"}
                                    title={
                                      account.distribution_mode_of_payment ||
                                      account.payment_method ||
                                      "N/A"
                                    }
                                    titleColor={"text-primary"}
                                    subtitle={TEXT?.PAYMENT_METHOD}
                                    info={false}
                                    showArrow={false}
                                    isBold={false}
                                    variant={"md"}
                                  />
                                </div>
                              </div>

                              <div className="border-primary-bg border-r border-solid hidden lg:block  py-padding-md"></div>
                              <div
                                className="lg:flex justify-center items-center hidden z-z-index-content absolute bottom-stepper-gap-between"
                                style={{
                                  left: "calc(var(--top-half) - var(--top-sm) )",
                                }}
                              >
                                <img
                                  src={ICONS?.ARROW_RIGHT_BLUE_WHITE}
                                  className="w-icon-md h-icon-md"
                                  alt="Transaction"
                                />
                              </div>
                              <div className="flex flex-row justify-between items-center gap-x-gap-md lg:gap-x-gap-xl pr-padding-md lg:pr-padding-base w-width-full lg:w-width-md">
                                <div className="hidden lg:flex flex-col justify-start items-start gap-y-gap-xs py-padding-sm mr-margin-xl ml-margin-md">
                                  <TitleSubtitlePair
                                    isDisabled={false}
                                    alignRight={false}
                                    title={
                                      account.beneficiary_account_ifsc_code
                                    }
                                    titleColor={"text-primary"}
                                    subtitle={TEXT?.IFSC}
                                    info={false}
                                    showArrow={false}
                                    isBold={false}
                                    variant={"md"}
                                  />
                                </div>
                              </div>
                            </div>
                            <div
                              className={`hidden lg:flex flex-row justify-end h-full align-bottom`}
                              style={{
                                height: "var(--height-full)",
                                width:
                                  "calc(var(--positive-negative-btn-width))",
                              }}
                            >
                              <div
                                className="w-width-full overflow-hidden flex justify-end"
                                style={{
                                  width: "calc(var(--topnav-small-btn-width))",
                                }}
                              >
                                <TopNavSmallButton
                                  isBackgroundRequired
                                  btnText={account?.category_id?.category_name}
                                  btnType="button"
                                  icon={categoryIcon.url}
                                  imgColor={categoryIcon.colour}
                                  handleFunction={() => {
                                    if (type === "bene_txn_detail_modal") {
                                      actionRestricted();
                                    } else {
                                      setHistoryPopup(true);
                                      setTxnHistoryId(
                                        account?.beneficiary_account_id,
                                      );
                                      setTxnHistoryAccountName(
                                        account?.beneficiary_account_name,
                                      );
                                      setcategoryName(
                                        viewTxnDetails[0]?.category_id
                                          ?.category_id,
                                      );
                                      setPopupCatName(
                                        viewTxnDetails[0]?.category_id
                                          ?.category_name,
                                      );
                                    }
                                  }}
                                  isDisabled={type === "bene_txn_detail_modal"}
                                  enabledTextColor="var(--text-primary)"
                                  enabledBgColor="var(--primary-nav-act)"
                                  disabledBgColor="var(--primary-nav-act)"
                                  hoverOption="white"
                                  fullWidthRequired={false}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>

              <div className="bg-primary-bg lg:hidden block lg:border-none border-primary-bg">
                <div className="flex flex-col w-width-full max-w-tab-width-normal m-auto">
                  {/* Mobile  */}
                  <TimelineStatusBar
                    showMobile={true}
                    key={viewTxnDetails?.[0]?.txn_id}
                    overrideAutoLoader
                    isLoading={loadingBox}
                    failedToTakeaction={
                      false || "" || viewTxnDetails?.[0]?.message
                    }
                    failedToTakeactionReason={
                      false
                        ? "An error occurred while taking action on this transaction"
                        : ""
                          ? ""
                          : viewTxnDetails?.[0]?.message || ""
                    }
                    rejected={
                      viewTxnDetails?.[0]?.lifecycle_status === "rejected"
                    }
                    rejectedReason={
                      viewTxnDetails?.[0]?.rejection_reason?.length >
                      RejectReasonLength.lengthOfDecline
                        ? viewTxnDetails?.[0]?.rejection_reason.slice(0, 150) +
                          "..."
                        : viewTxnDetails?.[0]?.rejection_reason
                    }
                    accountApprovalPending={
                      viewTxnDetails?.[0]
                        ?.beneficiary_account_approval_status === "pending" &&
                      viewTxnDetails?.[0]?.lifecycle_status !== "abandoned"
                    }
                    accountApprovalPendingSubHeader={
                      services?.includes("AReimbursementTxn")
                        ? "Account is not approved, approve account before approving transaction."
                        : "To approve the account, please contact the authorized person."
                    }
                    handleApprovalPendingBtn={() =>
                      services?.includes("RAAccount")
                        ? setBeneAccountDetailpop(true)
                        : navigate("/feature_not_assigned", {
                            state: {
                              unavailableService: "RAAccount",
                            },
                          })
                    }
                    isApprovalPendingDisabled={
                      services?.find((service) => service === "RAAccount") ===
                      undefined
                    }
                    furtherApprovalPending={
                      (viewTxnDetails?.[0]?.lifecycle_status === "pending" &&
                        viewTxnDetails?.[0]?.approved === "N" &&
                        viewTxnDetails?.[0]?.logs[
                          viewTxnDetails?.[0]?.logs.length -
                            GlobalConfiguration.lengthCheckOne
                        ]?.action?.toLowerCase() === "approved" &&
                        viewTxnDetails?.[0]?.logs[
                          viewTxnDetails?.[0]?.logs.length -
                            GlobalConfiguration.lengthCheckOne
                        ]?.user_id === loginid?.employees?.id) ||
                      (viewTxnDetails?.[0]?.last_updated_status ===
                        "Approved" &&
                        viewTxnDetails?.[0]?.lifecycle_status === "pending" &&
                        !services?.includes("AReimbursementTxn"))
                    }
                    furtherApprovalPendingSubHeader={
                      viewTxnDetails?.[0]?.lifecycle_status === "pending" &&
                      viewTxnDetails?.[0]?.approved === "N" &&
                      viewTxnDetails?.[0]?.logs[
                        viewTxnDetails?.[0]?.logs.length -
                          GlobalConfiguration.lengthCheckOne
                      ]?.action?.toLowerCase() === "approved" &&
                      viewTxnDetails?.[0]?.logs[
                        viewTxnDetails?.[0]?.logs.length -
                          GlobalConfiguration.lengthCheckOne
                      ]?.user_id === loginid?.employees?.id
                        ? "This transaction has been approved by you, but it requires another user's approval before distribution."
                        : viewTxnDetails?.[0]?.last_updated_status ===
                              "Approved" &&
                            viewTxnDetails?.[0]?.lifecycle_status ===
                              "pending" &&
                            !services?.includes("AReimbursementTxn")
                          ? "This transaction requires another user's approval before distribution."
                          : ""
                    }
                    pending={
                      viewTxnDetails?.[0]
                        ?.beneficiary_account_approval_status === "approved" &&
                      viewTxnDetails?.[0]?.lifecycle_status === "pending" &&
                      !approvalNotPermitted
                    }
                    whichBtnClicked={
                      btnClicked?.[viewTxnDetails?.[0]?.txn_id] || "none"
                    }
                    rejectMobClick={() => {
                      if (services?.includes("AReimbursementTxn")) {
                        setbtnClicked((prev) => ({
                          ...prev,
                          [viewTxnDetails?.[0]?.txn_id]: "Reject",
                        }));
                        handleDeclinedDetails(viewTxnDetails?.[0]?.txn_id);
                      } else {
                        navigate("/feature_not_assigned", {
                          state: {
                            unavailableService: "AReimbursementTxn",
                          },
                        });
                      }
                    }}
                    approvalNotPermitted={approvalNotPermitted}
                    isRejectMobDisable={
                      !services?.includes("AReimbursementTxn") ||
                      !checkTransaction
                    }
                    approveMobClick={() => {
                      if (services?.includes("AReimbursementTxn")) {
                        setbtnClicked((prev) => ({
                          ...prev,
                          [viewTxnDetails?.[0]?.txn_id]: "Approve",
                        }));
                        handleApproveTransaction(viewTxnDetails?.[0]?.txn_id);
                      } else {
                        navigate("/feature_not_assigned", {
                          state: {
                            unavailableService: "AReimbursementTxn",
                          },
                        });
                      }
                    }}
                    isApproveMobDisable={
                      !services?.includes("AReimbursementTxn") ||
                      !checkTransaction
                    }
                  />

                  <div className="flex flex-col w-width-full my-margin-md">
                    <div className="py-padding-sm px-padding-md bg-primary-card text-font-sm text-text-primary text-left font-semibold w-width-full">
                      Quick Action
                    </div>

                    <div className="grid grid-cols-2 w-width-full bg-primary-nav border-b border-primary-bg">
                      <div className="relative">
                        <TopNavSmallButton
                          btnText={
                            <>
                              {TEXT?.TRANSACTION}
                              <br />
                              {TEXT?.HISTORY}
                            </>
                          }
                          btnType="button"
                          icon={ICONS?.TRANSACTION_HISTORY}
                          handleFunction={() => {
                            if (type === "bene_txn_detail_modal") {
                              actionRestricted();
                            } else {
                              setHistoryPopup(true);
                              setTxnHistoryId(
                                viewTxnDetails[0]?.beneficiary_account_id,
                              );
                              setTxnHistoryAccountName(
                                viewTxnDetails[0]?.beneficiary_account_name,
                              );
                              setcategoryName("");
                            }
                          }}
                          isDisabled={type === "bene_txn_detail_modal"}
                          disabledBgColor="var(--primary-nav-act)"
                          enabledTextColor="var(--text-primary)"
                          enabledBgColor="var(--primary-nav-act)"
                          hoverOption="white"
                          fullWidthRequired={true}
                        />
                        <div className="absolute top-top-base right-right-base h-height-full border-r border-primary-bg"></div>
                      </div>

                      <TopNavSmallButton
                        isBackgroundRequired
                        btnText={viewTxnDetails[0]?.category_id?.category_name}
                        btnType="button"
                        icon={categoryIcon.url}
                        imgColor={categoryIcon.colour}
                        handleFunction={() => {
                          if (type === "bene_txn_detail_modal") {
                            actionRestricted();
                          } else {
                            setHistoryPopup(true);
                            setTxnHistoryId(
                              viewTxnDetails[0]?.beneficiary_account_id,
                            );
                            setTxnHistoryAccountName(
                              viewTxnDetails[0]?.beneficiary_account_name,
                            );
                            setcategoryName(
                              viewTxnDetails[0]?.category_id?.category_name,
                            );
                          }
                        }}
                        isDisabled={type === "bene_txn_detail_modal"}
                        enabledTextColor="var(--text-primary)"
                        enabledBgColor="var(--primary-nav-act)"
                        disabledBgColor="var(--primary-nav-act)"
                        hoverOption="white"
                        fullWidthRequired={true}
                      />
                    </div>
                    <div
                      className={`grid w-width-full bg-primary-nav grid-cols-2
                       border-b border-primary-bg`}
                    >
                      <div className="relative">
                        <TopNavSmallButton
                          btnText={
                            <>
                              {TEXT?.ASSIGN}
                              <br />
                              {TEXT?.LABELS}
                            </>
                          }
                          btnType="button"
                          icon={ICONS?.LABEL_WITH_CIRCLE}
                          handleFunction={(e) => {
                            e.stopPropagation();
                            if (
                              !services?.includes("ALabel") &&
                              !services?.includes("RLabel")
                            ) {
                              navigate("/feature_not_assigned", {
                                state: { unavailableService: "ALabel,RLabel" },
                              });
                              return;
                            }
                            if (type === "bene_txn_detail_modal") {
                              actionRestricted();
                              return;
                            }
                            setShowLabelsPopup(true);
                          }}
                          isDisabled={
                            type === "bene_txn_detail_modal" ||
                            (!services?.includes("ALabel") &&
                              !services?.includes("RLabel"))
                          }
                          enabledTextColor="var(--text-primary)"
                          enabledBgColor="var(--primary-nav-act)"
                          disabledBgColor="var(--primary-nav-act)"
                          hoverOption="white"
                          fullWidthRequired={true}
                        />
                        <div className="absolute top-top-base right-right-base h-height-full border-r border-primary-bg"></div>
                      </div>

                      <div className=" relative w-full ">
                        <TopNavSmallButton
                          btnText={
                            <>
                              Linked
                              <br />
                              request
                            </>
                          }
                          btnType="button"
                          icon={ICONS?.LINKED_WHITE_CIRCLE}
                          handleFunction={() => {
                            if (type === "bene_txn_detail_modal") {
                              actionRestricted();
                            } else if (
                              viewTxnDetails[0]?.reimbursement_request_id
                            ) {
                              navigate(
                                `/reimbursement_transaction_dashboard/reimbursement_request_view_all/reimbursement_request_detail_page/${viewTxnDetails[0]?.reimbursement_request_id}`,
                              );
                            } else {
                              return;
                            }
                          }}
                          isDisabled={
                            type === "bene_txn_detail_modal"
                              ? true
                              : !viewTxnDetails[0]?.reimbursement_request_id
                                ? true
                                : false
                          }
                          enabledTextColor="var(--text-primary)"
                          enabledBgColor="var(--primary-nav-act)"
                          disabledBgColor="var(--primary-nav-act)"
                          hoverOption="white"
                          fullWidthRequired={true}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {isOutsideBankingHoursActive &&
                viewTxnDetails[0]?.lifecycle_status === "pending" && (
                  <div className="lg:mx-auto flex Qlg:flex-row flex-col z-z-index-content lg:mt-margin-md mt-margin-base mx-margin-md max-w-tab-width-normal mb-margin-md Qmd:mb-margin-base">
                    <CommonAlertCard
                      title={"Functioning outside banking hours"}
                      texts={
                        <>
                          Transactions will be processed automatically during
                          the next bank working day.{" "}
                          <span
                            className="underline cursor-pointer font-semibold"
                            onClick={() => handleOpenBanner()}
                          >
                            Learn more
                          </span>
                        </>
                      }
                    />
                  </div>
                )}
              <div className="flex-row w-width-full timeline_box max-w-tab-width-normal m-auto flex items-end ">
                <div
                  className={`bg-primary-card flex flex-col w-full lg:w-width-md mx-margin-md lg:mx-margin-base h-auto mt-margin-base Qsmd:mt-margin-md overflow-hidden relative rounded-bl-border-radius-md rounded-t-border-radius-md
                   ${
                     ReimbursementTxnAccountData?.transaction?.[0]
                       ?.distribution_lifecycle_status !== "created" ||
                     viewTxnDetails?.[0]?.lifecycle_status === "rejected"
                       ? "rounded-bl-border-radius-md Qlg:rounded-br-none rounded-br-border-radius-md"
                       : (viewTxnDetails?.[0]
                             ?.beneficiary_account_approval_status ===
                             "approved" &&
                             ReimbursementTxnAccountData?.transaction?.[0]
                               ?.distribution_lifecycle_status === "created") ||
                           viewTxnDetails?.[0]?.lifecycle_status === "pending"
                         ? "rounded-b-border-radius-md"
                         : "rounded-bl-border-radius-md rounded-br-none"
                   }

                `}
                >
                  <div
                    className={`flex flex-col ${type === "bene_txn_detail_modal" && "opacity-light-opacity cursor-not-allowed"} w-full  h-auto   ${
                      viewTxnDetails?.[0]
                        ?.beneficiary_account_approval_status === "approved" &&
                      viewTxnDetails?.[0].lifecycle_status === "pending"
                        ? " rounded-bl-border-radius-md  rounded-br-border-radius-md"
                        : "rounded-b-border-radius-md"
                    } rounded-t-border-radius-md overflow-hidden relative`}
                  >
                    {/* TITLE */}
                    <div
                      className={`pt-px bg-primary-nav  rounded-tl-border-radius-md px-padding-md rounded-tr-border-radius-md`}
                    >
                      <p className="text-text-primary text-font-xs text-left font-semibold my-margin-sm">
                        Transaction Timeline
                      </p>
                      <div className="border-b border-primary-bg"></div>
                    </div>

                    <div ref={leftContentRef}>
                      <CommonTimeLineCard
                        logsData={viewTxnDetails}
                        handleApprovalClick={handleTimelinePopup}
                        handleDistributionClick={handleDistributionClick}
                        showApprovalTimeline={showApprovalTimeline}
                        showDistributionTimeline={showDistributionTimeline}
                        showDistributionRightIcon={true}
                        showApprovalLeftIcon={true}
                        isDisabled={
                          type === "bene_txn_detail_modal" ? true : false
                        }
                        cardType={"double"}
                      />
                    </div>
                  </div>
                </div>

                <div
                  className={`hidden lg:flex flex-col flex-grow mt-margin-md w-width-md`}
                >
                  {/* Web Timeline Component  */}
                  <TimelineStatusBar
                    showMobile={false}
                    key={viewTxnDetails?.[0]?.txn_id}
                    overrideAutoLoader
                    isLoading={loadingBox}
                    failedToTakeaction={
                      false || "" || viewTxnDetails?.[0]?.message
                    }
                    failedToTakeactionReason={
                      false
                        ? "An error occurred while taking action on this transaction"
                        : ""
                          ? ""
                          : viewTxnDetails?.[0]?.message || ""
                    }
                    rejected={
                      viewTxnDetails?.[0]?.lifecycle_status === "rejected"
                    }
                    rejectedReason={
                      viewTxnDetails?.[0]?.rejection_reason?.length >
                      RejectReasonLength.lengthOfDecline
                        ? viewTxnDetails?.[0]?.rejection_reason.slice(0, 150) +
                          "..."
                        : viewTxnDetails?.[0]?.rejection_reason
                    }
                    accountApprovalPending={
                      viewTxnDetails?.[0]
                        ?.beneficiary_account_approval_status === "pending" &&
                      viewTxnDetails?.[0]?.lifecycle_status !== "abandoned"
                    }
                    accountApprovalPendingSubHeader={
                      services?.includes("AReimbursementTxn")
                        ? "Account is not approved, approve account before approving transaction."
                        : "To approve the account, please contact the authorized person."
                    }
                    handleApprovalPendingBtn={() =>
                      services?.includes("RAAccount")
                        ? setBeneAccountDetailpop(true)
                        : navigate("/feature_not_assigned", {
                            state: {
                              unavailableService: "RAAccount",
                            },
                          })
                    }
                    isApprovalPendingDisabled={
                      services?.find((service) => service === "RAAccount") ===
                      undefined
                    }
                    furtherApprovalPending={
                      (viewTxnDetails?.[0]?.lifecycle_status === "pending" &&
                        viewTxnDetails?.[0]?.approved === "N" &&
                        viewTxnDetails?.[0]?.logs[
                          viewTxnDetails?.[0]?.logs.length -
                            GlobalConfiguration.lengthCheckOne
                        ]?.action?.toLowerCase() === "approved" &&
                        viewTxnDetails?.[0]?.logs[
                          viewTxnDetails?.[0]?.logs.length -
                            GlobalConfiguration.lengthCheckOne
                        ]?.user_id === loginid?.employees?.id) ||
                      (viewTxnDetails?.[0]?.last_updated_status ===
                        "Approved" &&
                        viewTxnDetails?.[0]?.lifecycle_status === "pending" &&
                        !services?.includes("AReimbursementTxn"))
                    }
                    furtherApprovalPendingSubHeader={
                      viewTxnDetails?.[0]?.lifecycle_status === "pending" &&
                      viewTxnDetails?.[0]?.approved === "N" &&
                      viewTxnDetails?.[0]?.logs[
                        viewTxnDetails?.[0]?.logs.length -
                          GlobalConfiguration.lengthCheckOne
                      ]?.action?.toLowerCase() === "approved" &&
                      viewTxnDetails?.[0]?.logs[
                        viewTxnDetails?.[0]?.logs.length -
                          GlobalConfiguration.lengthCheckOne
                      ]?.user_id === loginid?.employees?.id
                        ? "This transaction has been approved by you, but it requires another user's approval before settlement."
                        : viewTxnDetails?.[0]?.last_updated_status ===
                              "Approved" &&
                            viewTxnDetails?.[0]?.lifecycle_status ===
                              "pending" &&
                            !services?.includes("AReimbursementTxn")
                          ? "This transaction requires another user's approval before settlement."
                          : ""
                    }
                    pending={
                      viewTxnDetails?.[0]
                        ?.beneficiary_account_approval_status === "approved" &&
                      viewTxnDetails?.[0]?.lifecycle_status === "pending" &&
                      !approvalNotPermitted
                    }
                    approvalNotPermitted={approvalNotPermitted}
                    whichBtnClicked={
                      btnClicked?.[viewTxnDetails?.[0]?.txn_id] || "none"
                    }
                    rejectClick={() => {
                      if (services?.includes("AReimbursementTxn")) {
                        setbtnClicked((prev) => ({
                          ...prev,
                          [viewTxnDetails?.[0]?.txn_id]: "Reject",
                        }));
                        handleDeclinedDetails(viewTxnDetails?.[0]?.txn_id);
                      } else {
                        navigate("/feature_not_assigned", {
                          state: {
                            unavailableService: "AReimbursementTxn",
                          },
                        });
                      }
                    }}
                    isRejectDisable={!services?.includes("AReimbursementTxn")}
                    approveClick={() => {
                      if (services?.includes("AReimbursementTxn")) {
                        setbtnClicked((prev) => ({
                          ...prev,
                          [viewTxnDetails?.[0]?.txn_id]: "Approve",
                        }));
                        handleApproveTransaction(viewTxnDetails?.[0]?.txn_id);
                      } else {
                        navigate("/feature_not_assigned", {
                          state: {
                            unavailableService: "AReimbursementTxn",
                          },
                        });
                      }
                    }}
                    isApproveDisable={!services?.includes("AReimbursementTxn")}
                  />
                </div>
              </div>

              <div
                className={`details-div-trans lg:mb-margin-md bg-primary-bg lg:pt-padding-base ${
                  type === "bene_txn_detail_modal" ? "w-width-full" : "w-screen"
                }`}
              >
                <div className="detail-section-trans h-auto bg-primary-bg m-auto max-w-tab-width-normal">
                  <div className="mt-margin-md flex">
                    <div className="flex gap-gap-sm bg-primary-card w-auto ml-margin-md lg:ml-margin-base rounded-border-radius-md overflow-x-auto">
                      <SwitcherTabs
                        initialActiveTab={
                          showSupportDetails
                            ? "Support details"
                            : showAssignedLabels
                              ? "Labels"
                              : "Category specific details"
                        }
                        tabs={[
                          {
                            label: "Category specific details",
                            key: "Category specific details",
                            handler: toggleDetails,
                          },
                          {
                            label: "Labels",
                            key: "Labels",
                            handler: toggleAssignedLabels,
                          },
                          {
                            label: "Support details",
                            key: "Support details",
                            handler: toggleSupportDetails,
                          },
                        ]}
                        setIndex={setIndex}
                      />
                    </div>
                  </div>
                  {index === GlobalConfiguration?.lengthCheckTwo && (
                    <div className={animationClass}>
                      {viewTxnDetails?.map((account) => {
                        let originItemList = [
                          {
                            content:
                              (account?.logs?.[0]?.user_full_name ?? "") +
                              " " +
                              (account?.logs?.[0]?.last_name
                                ? account.logs[0].last_name[0]?.toUpperCase() +
                                  account.logs[0].last_name.slice(1)
                                : ""),
                            heading: "Created by",
                            type: "text",
                          },
                          {
                            content: formatDateViewAll(
                              account?.created_on,
                              true,
                              true,
                            ),
                            heading: "Created on",
                            type: "text",
                          },
                          {
                            content: account?.logs?.[0]?.user_id ?? "",
                            heading: "User ID",
                            type: "text",
                          },
                        ];

                        let supportItemList = [
                          {
                            content: account?.txn_id,
                            heading: "Transaction ID",
                            type: "textWithButton",
                            iconArray: [
                              {
                                onClick: (e) => {
                                  setSupportInfoTT("Copied");
                                  setTxnId(true);
                                  setCopyDistributionId(false);
                                  if (account?.txn_id) {
                                    navigator.clipboard.writeText(
                                      account.txn_id,
                                    );
                                  }
                                  setTimeout(() => {
                                    setSupportInfoTT(supportInfoTTDefaultText);
                                  }, IntervalConfiguration.intervalMedium);
                                },
                                title: supportInfoTT,
                                icon:
                                  supportInfoTT === "Copied" && copyTxnId
                                    ? ICONS?.SELECTED_WITH_GREEN_CIRCLE
                                    : ICONS?.COPY,
                              },
                            ],
                          },
                        ];

                        if (account?.distribution_id) {
                          supportItemList.push({
                            content: account?.distribution_id,
                            heading: "Distribution ID",
                            type: "textWithButton",
                            iconArray: [
                              {
                                onClick: (e) => {
                                  setSupportInfoTT("Copied");
                                  setCopyDistributionId(true);
                                  setTxnId(false);
                                  if (account?.distribution_id) {
                                    navigator.clipboard.writeText(
                                      account.distribution_id,
                                    );
                                  }
                                  setTimeout(() => {
                                    setSupportInfoTT(supportInfoTTDefaultText);
                                  }, IntervalConfiguration.intervalMedium);
                                },
                                title: supportInfoTT,
                                icon:
                                  supportInfoTT === "Copied" &&
                                  copyDistributionId
                                    ? ICONS?.SELECTED_WITH_GREEN_CIRCLE
                                    : ICONS?.COPY,
                              },
                            ],
                          });
                        }
                        return (
                          <div
                            className={`flex flex-col lg:flex-row my-margin-md px-padding-md lg:px-padding-base ${
                              account?.distribution_lifecycle_status ===
                              "distribution_complete"
                                ? "justify-between gap-gap-md"
                                : "gap-gap-md lg:gap-gap-md"
                            }`}
                          >
                            <CommonDetailCard
                              cardTitle={TEXT?.ORIGIN_DETAILS}
                              variant="third"
                              numCols={GlobalConfiguration?.lengthCheckOne}
                              entries={originItemList}
                            />

                            <CommonDetailCard
                              cardTitle={TEXT?.SUPPORT_INFORMATION}
                              numCols={GlobalConfiguration?.lengthCheckOne}
                              variant="third"
                              entries={supportItemList}
                            />
                          </div>
                        );
                      })}
                    </div>
                  )}
                  {index === GlobalConfiguration?.lengthCheckZero && (
                    <div className={animationClass}>
                      <div className="flex flex-col lg:flex-row items-start gap-gap-md pb-padding-md text-text-primary mt-margin-md px-padding-md lg:px-padding-base">
                        <>
                          {validItems?.filter(
                            (item) =>
                              item.name !== "Hyperlink" &&
                              item.name !== "File" &&
                              item.name !== "Image",
                          ).length === GlobalConfiguration.lengthCheckZero ? (
                            <div className="flex flex-col p-padding-md gap-gap-md bg-primary-card rounded-border-radius-md">
                              <div className="text-text-primary text-font-sm font-semibold capitalize">
                                {TEXT?.CATEGORY_SPECIFIC_DETAILS}
                              </div>
                              <p className="text-text-secondary text-font-xs font-normal">
                                Additional details are not supported for the
                                selected category.
                              </p>
                            </div>
                          ) : (
                            <>
                              {(() => {
                                const filteredItems = validItems.filter(
                                  (item) =>
                                    item.data_type.toLowerCase() !==
                                      "hyperlink" &&
                                    item.data_type !== "File" &&
                                    item.data_type !== "Image" &&
                                    item.data_type !== "upload",
                                );

                                return (
                                  <>
                                    {!!filteredItems.length && (
                                      <CommonDetailCard
                                        cardTitle={
                                          TEXT?.CATEGORY_SPECIFIC_DETAILS
                                        }
                                        numCols={
                                          filteredItems.length ===
                                          GlobalConfiguration.lengthCheckOne
                                            ? GlobalConfiguration.lengthCheckOne
                                            : TimelineConfiguration.barWidthMedium
                                        }
                                        variant="third"
                                        entries={filteredItems.map(
                                          (subItem, index) => {
                                            switch (subItem.data_type) {
                                              case "toggle":
                                                return {
                                                  content: subItem?.value
                                                    ? "Yes"
                                                    : "No",
                                                  heading: subItem?.name,
                                                  type: "text",
                                                };
                                              case "multi_select_list":
                                                return {
                                                  content:
                                                    subItem?.value?.length !==
                                                    GlobalConfiguration.lengthCheckZero
                                                      ? subItem?.value?.join(
                                                          ", ",
                                                        )
                                                      : "Not Given",
                                                  heading: subItem?.name,
                                                  type: "text",
                                                };
                                              case "date_range":
                                                return {
                                                  content: subItem?.value
                                                    ?.start_date
                                                    ? `${subItem.value.start_date} - ${subItem.value.end_date}`
                                                    : "Not Given",
                                                  heading:
                                                    "From date - To date",
                                                  type: "text",
                                                };
                                              case "from_year_to_year":
                                                return {
                                                  content: subItem?.value?.from
                                                    ? `${subItem.value.from} - ${subItem.value.to}`
                                                    : "Not Given",
                                                  heading:
                                                    "From year - To year",
                                                  type: "text",
                                                };
                                              default:
                                                return {
                                                  content:
                                                    subItem?.value ??
                                                    "Not Given",
                                                  heading: subItem?.name,
                                                  type: "text",
                                                  onClick: undefined,
                                                };
                                            }
                                          },
                                        )}
                                      />
                                    )}
                                  </>
                                );
                              })()}
                            </>
                          )}
                        </>

                        {attachments.length >
                          GlobalConfiguration.lengthCheckZero && (
                          <>
                            <CommonDetailCard
                              cardTitle={TEXT?.ATTACHMENTS}
                              numCols={GlobalConfiguration?.lengthCheckOne}
                              variant="third"
                              entries={attachments.map((obj, index) => {
                                switch (obj.data_type.toLowerCase()) {
                                  case "hyperlink":
                                    return {
                                      content: obj?.value ?? "#",
                                      heading: "URL",
                                      type: "link",
                                    };
                                  default: {
                                    let ob = obj.value;
                                    const mt =
                                      ob?.metadata?.mime_type ??
                                      "application/octet-stream";
                                    switch (true) {
                                      case mt?.startsWith("image/"):
                                        return {
                                          content: {
                                            fileName: ob?.metadata?.filename,
                                            size: ob?.metadata?.size ?? "0",
                                            mimeType: mt,
                                            url: ob?.file_url,
                                            onUrlClick: () => {
                                              setOpenImageUrl(true);
                                              setSelectedImage({
                                                name: ob?.metadata?.filename,
                                                url: ob?.file_url,
                                              });
                                            },
                                          },
                                          heading:
                                            ob?.metadata?.filename || "Image",
                                          type: "image",
                                        };
                                      default:
                                        return {
                                          content: {
                                            fileName: ob?.metadata?.filename,
                                            size: ob?.metadata?.size ?? "0",
                                            mimeType: mt,
                                            onUrlClick: () => {
                                              window
                                                .open(ob?.file_url, "_blank")
                                                .focus();
                                            },

                                            url: ob?.file_url,
                                          },
                                          heading:
                                            ob?.metadata?.filename || "File",
                                          type: "file",
                                        };
                                    }
                                  }
                                }
                              })}
                            />
                          </>
                        )}
                      </div>
                    </div>
                  )}

                  {index === GlobalConfiguration?.lengthCheckOne && (
                    <div className={animationClass}>
                      <div className="mt-margin-md mb-margin-md">
                        <CommonContainerCard
                          header="Labels"
                          iconIsDisabled={
                            !(
                              services?.includes("ALabel") &&
                              services?.includes("RLabel")
                            ) || type === "bene_txn_detail_modal"
                          }
                          subheader={TEXT?.LABELS_USAGE_NOTE}
                          icon={ICONS?.EDIT}
                          handleFunction={(e) => {
                            e.stopPropagation();

                            if (!(
                              services?.includes("ALabel") &&
                              services?.includes("RLabel")
                            )) {
                              navigate("/feature_not_assigned", {
                                state: {
                                  unavailableService: "ALabel,RLabel",
                                },
                              });
                              return;
                            }

                            if (type === "bene_txn_detail_modal") {
                              actionRestricted();
                              return;
                            }

                            setShowLabelsPopup(true);
                          }}
                        >
                          <div className="flex flex-wrap w-width-full gap-gap-sm overflow-x-auto">
                            {Array.isArray(labelDetails) &&
                            labelDetails.length ? (
                              <>
                                {labelDetails.map((item, index) => (
                                  <Chips
                                    key={index}
                                    txtChip={item}
                                    enabledBgColor="var(--primary-nav)"
                                    disableIcon={true}
                                    handleFunctionBtn={(e) => {
                                      if (type === "bene_txn_detail_modal") {
                                        actionRestricted();
                                      } else {
                                        setHistoryPopup(true);
                                        setTxnLabelFilter(item);
                                        setTxnHistoryId("");
                                        setTxnHistoryAccountName("");
                                        setcategoryName("");
                                      }
                                    }}
                                    enabledTextColor="var(--text-primary)"
                                    isTickerRequired={false}
                                  />
                                ))}
                              </>
                            ) : (
                              <p className="text-font-sm text-text-primary">
                                Not assigned.
                              </p>
                            )}
                          </div>
                        </CommonContainerCard>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default ReimbursementTxnDetails;
